/* eslint-disable react-hooks/exhaustive-deps */

import * as Icon from 'base/ui/components/Icons';

import { Form, Radio, Spin, message } from 'antd';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { catalogPresenter, catalogStore, userStore, workPresenter, workStore } from 'stores/root_store';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import BoxContainer from 'base/ui/components/BoxContainer';
import CustomBreadcrumb from 'base/ui/components/CustomBreadcrumb';
import CustomButton from 'base/ui/components/Button';
import CustomInput from 'base/ui/components/CustomInput';
import CustomInputNumber from 'base/ui/components/CustomInputNumber';
import CustomSelect from 'base/ui/components/CustomSelect';
import { SYSTEM_TITLE } from 'utils/constants';
import { observer } from 'mobx-react';
import { removeEmptyValues } from 'utils/transformHelper';
import { usePermission } from 'hooks/usePermission';
import { useTranslation } from 'react-i18next';

const createAddUpdateTask = () => {
  return observer(() => {
    const { t } = useTranslation();

    // Get data params from url
    const { id: idParams } = useParams();
    // Check id để đặt tên trang
    let pageTitle = '';

    // Nếu có id là chỉnh sửa (xem chi tiết)
    if (idParams) {
      // Kiểm tra phân quyền
      usePermission('INDEX'); // Kiểm tra xem được quyền truy cập vào trang
      pageTitle = t('page-title.update');
      document.title = pageTitle + ' - ' + SYSTEM_TITLE;
    } else {
      // Kiểm tra phân quyền
      usePermission('CREATE');
      pageTitle = t('page-title.create');
      document.title = pageTitle + ' - ' + SYSTEM_TITLE;
    }
    const navigate = useNavigate();
    // Check button save and save continue
    let isSaveAndContinue = false;
    const [form] = Form.useForm();
    // Loading
    const [loading, setLoading] = useState(false);

    // =================================================================================================
    //===============================================FUNCTION=====================================//
    // Call api detail store
    const getDetail = async (id: string) => {
      await workPresenter.getWorkById(workStore, id);
      if (workStore.detailWork.isSuccess) {
        form.setFieldsValue(workStore.detailWork.data);
        setLoading(false);
      } else {
        navigate('/MasterData/Task');
      }
    };

    // Handle create or update
    const onFinish = async (values: any) => {
      setLoading(true);
      removeEmptyValues(values);
      if (!idParams) {
        await workPresenter.createWork(workStore, values);
        if (workStore.crudResponse.isSuccess) {
          message.success(workStore.crudResponse.message);
          // Redirect to search page routing (Button Save)
          if (!isSaveAndContinue) {
            navigate('/MasterData/Task');
          }
          form.resetFields();
        }
      } else {
        await workPresenter.updateWork(workStore, {
          ...values,
          workId: idParams,
        });
        if (workStore.crudResponse.isSuccess) {
          message.success(workStore.crudResponse.message);
          // Redirect to search page routing (Button Save)
          if (!isSaveAndContinue) {
            navigate('/MasterData/Task');
          }
        }
      }
      setLoading(false);
    };

    const initialValues = {
      actived: true,
    };

    useEffect(() => {
      (async () => {
        await catalogPresenter.getDropdownWorkType(catalogStore);
        if (idParams) {
          setLoading(true);
          await getDetail(idParams);
        }
      })();
    }, []);

    function ButtonCreateUpdate() {
      return (
        <>
          <CustomButton
            icon={<Icon.Download className="!fill-[#262626]" />}
            htmlType="submit"
            disabled={loading}
            loading={loading}
            onClick={() => {
              isSaveAndContinue = false;
              form.submit();
            }}
          >
            {t('btn.save')}
          </CustomButton>
          <CustomButton
            type="primary"
            icon={<Icon.Download />}
            disabled={loading}
            loading={loading}
            onClick={() => {
              isSaveAndContinue = true;
              form.submit();
            }}
          >
            {idParams ? t('btn.save-update') : t('btn.save-continue-create')}
          </CustomButton>
        </>
      );
    }

    return (
      <>
        <div className="flex flex-col h-full">
          <CustomBreadcrumb
            pagetitle={[
              {
                title: 'Công việc',
                link: '/MasterData/Task',
              },
              {
                title: pageTitle,
                link: idParams ? `/MasterData/Ward/${idParams}` : '/MasterData/Task/create',
              },
            ]}
            extra={
              <>
                <div className="custom__mobile--save flex space-x-2">
                  {!idParams && userStore.userPermission?.includes('CREATE') ? <ButtonCreateUpdate /> : null}
                  {idParams && userStore.userPermission?.includes('EDIT') ? <ButtonCreateUpdate /> : null}
                </div>
              </>
            }
          />

          {/* Form nhập tìm kiếm */}
          <BoxContainer fullHeight>
            <Spin spinning={loading}>
              <SearchForm onFinish={onFinish} initialValues={idParams ? {} : initialValues} form={form}>
                {/* Tên công việc */}
                <SearchItem
                  rules={[{ required: true, message: 'Hãy nhập thông tin cho trường tên công việc' }]}
                  name={'workName'}
                  label={t('Tên công việc')}
                >
                  <CustomInput />
                </SearchItem>
                {/* loại công việc */}
                <SearchItem label={t('Loại công việc')} name={'worktypeCode'}>
                  <CustomSelect
                    fieldNames={{ value: 'catalogCode', label: 'catalogName' }}
                    options={catalogStore.workType.data}
                  />
                </SearchItem>
                {/* Giờ công */}
                <SearchItem name={'workHour'} label={t('Giờ công')}>
                  <CustomInputNumber controls={false} className="!w-full" />
                </SearchItem>
                {/* Giá */}
                <SearchItem name={'price'} label={t('Giá')}>
                  <CustomInputNumber
                    controls={false}
                    className="!w-full"
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                    addonAfter="VND"
                  />
                </SearchItem>
                {/* trạng thái */}
                <SearchItem name={'actived'} label={t('Trạng thái')}>
                  <Radio.Group>
                    <Radio value={true}>{t('radio-btn.active')}</Radio>
                    <Radio value={false}>{t('radio-btn.in-active')}</Radio>
                  </Radio.Group>
                </SearchItem>
              </SearchForm>
            </Spin>
          </BoxContainer>
        </div>
      </>
    );
  });
};

export default createAddUpdateTask;
